import { ReactElement, useState, useEffect, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Input } from '~/components';
import { useLoading } from '~/hooks/loading';
import { ISymbology } from '~/models/Symbology';
import { SymbologyService } from '~/services';

import * as S from './styles';

interface IEditExerciseFormProps {
  formName: string;
  formRef: React.RefObject<FormHandles>;
  handleSubmit: (data: ISymbology) => void;
}

interface ICadasterParams {
  symbologyId: string;
}

function EditSymbologyForm({
  formName,
  formRef,
  handleSubmit,
}: IEditExerciseFormProps): ReactElement {
  const { setLoading } = useLoading();

  const { symbologyId } = useParams<ICadasterParams>();

  const [simbology, setSymbology] = useState<ISymbology>();

  const handleGetSegments = useCallback(async () => {
    try {
      setLoading(true);

      const response = await SymbologyService.getOneSymbology(symbologyId!);
      setSymbology(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao carregar os dados!');
    }
  }, [symbologyId]);

  useEffect(() => {
    if (symbologyId) {
      handleGetSegments();
    }
  }, [handleGetSegments, symbologyId]);

  return (
    <S.FormWrapper
      id={formName}
      ref={formRef}
      onSubmit={handleSubmit}
      initialData={simbology}
    >
      <Input name="stimulus" label="Estímulo" />
      <Input name="symbology" label="Simbologia" />
      <Input name="application_in_method" label="Aplicação do método" />
      <Input name="example" label="Exemplo" />
    </S.FormWrapper>
  );
}

EditSymbologyForm.defaultProps = {};

export default EditSymbologyForm;
